import React, { useEffect, useState } from 'react';
import {  Nav, NavItem, NavLink } from "reactstrap";
import classNames from "classnames";
import { PROGRAM_LIST_TABS } from "./constants";
import ProgramsList from "./ProgramsList";
import BaseLayoutWithCard from "../../../../../base/components/BaseLayoutWithCard";
import PredefinedList from "./PredefinedList";
import { useNavigate } from "react-router-dom";


const breadcrumbs = {
    title: "Nutrition", breadcrumbItems: []
};

export default function List() {

    const [activeTab, updateActiveTab] = useState(PROGRAM_LIST_TABS.PROGRAMS);

    const tabComponents = {
        [PROGRAM_LIST_TABS.PROGRAMS]: <ProgramsList />,
        [PROGRAM_LIST_TABS.PREDEFINED]: <PredefinedList />
    }

    let navigate = useNavigate();

    const clearQueryParams = () => {
        navigate(window.location.pathname, { replace: true });
    };

    useEffect(() => {
        clearQueryParams()
    }, [activeTab]);

    return (
            <BaseLayoutWithCard breadcrumbs={breadcrumbs} >
                            <Nav tabs className="nav-tabs-custom mt-1">
                                {Object.values(PROGRAM_LIST_TABS).map((label, index) => (
                                    <NavItem key={`navItem${index}`}>
                                        <NavLink
                                            className={classNames(
                                                {
                                                    active: activeTab === label
                                                },
                                                "cursor-pointer py-1 mx-1"
                                            )}
                                            onClick={() => updateActiveTab(label)}
                                        >
                                            <span>{label}</span>
                                        </NavLink>
                                    </NavItem>
                                ))}
                            </Nav>

                            {tabComponents[activeTab]}
            </BaseLayoutWithCard>
    );
}
